const DefaultRowLayout = ({children}: any) => {

    return (
        <div className={'row gx-0'} data-masonry='{"percentPosition": true }'>{children}</div>
    )
}

export default DefaultRowLayout